import cornerstone from 'cornerstone-core';

import { formatDICOMDate, formatPN } from '../formatStudy';

/**
 * Builds the patient/study block that is repeated on every printed sheet.
 *
 * The values come from the cornerstone metadata providers (the same source the
 * viewport overlay reads), so anything already displayed on screen is
 * available here without going back to the study metadata.
 *
 * @param {string} imageId any imageId of the series being printed
 * @param {Object} [displaySet] used as a fallback for series level fields
 * @returns {Object} { patientName, patientId, studyDate, studyDescription, seriesDescription, modality, institution }
 */
export default function getPrintHeader(imageId, displaySet = {}) {
  const patient = cornerstone.metaData.get('patientModule', imageId) || {};
  const study = cornerstone.metaData.get('generalStudyModule', imageId) || {};
  const series = cornerstone.metaData.get('generalSeriesModule', imageId) || {};
  // InstitutionName is not part of any of the wado-image-loader modules.
  const instance = cornerstone.metaData.get('instance', imageId) || {};

  return {
    patientName: formatPN(patient.patientName) || '',
    patientId: patient.patientId || '',
    studyDate: study.studyDate ? formatDICOMDate(study.studyDate) : '',
    studyDescription: study.studyDescription || '',
    seriesDescription:
      series.seriesDescription || displaySet.SeriesDescription || '',
    modality: series.modality || displaySet.Modality || '',
    institution: instance.InstitutionName || '',
  };
}
